import React, { useState, useEffect } from 'react';
import Rodal from 'rodal';
import moment from 'moment';

import {
  ANALYTICS_CATEGORIES,
  ANALYTICS_ACTIONS,
  sendEvent,
} from '../../components/analytics';

import { fromQueryParams } from '../../utils';

import './style.scss';

const heartFilled = require('../../assets/icons/heart-filled.png');
const locationPin = require('../../assets/icons/pin-filled.png');

const Elections = (props) => {
  const {
    elections,
    history,
    isLoggedIn,
    queriedAddress,
    queriedElections,
    setSelectedElection,
    setUserAddress,
    setUserSeenAddressPrompt,
    user,
    userElectionsByAddress,
    userSavedElections,
    userSeenAddressPrompt,
  } = props;

  const { found: foundElections } = fromQueryParams(history?.location?.search || '');

  const [isLoading, setIsLoading] = useState(elections.length === 0);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    setIsLoading(elections.length === 0);
  }, [elections]);

  const electionsToDisplay = foundElections === 'multiple' ? Object.values(queriedElections) : elections;

  const electionsByMonth = (electionsToDisplay.length > 0 ? electionsToDisplay : elections).reduce((acc, curr) => {
    const month = moment(curr.date).utc().format('MMMM');

    return {
      ...acc,
      [month]: [...(acc[month] || []), curr],
    };
  }, {});

  useEffect(() => {
    if (isLoggedIn && queriedAddress && user && user.street_address !== queriedAddress && !userSeenAddressPrompt) {
      setModalVisible(true);
    }
  }, [isLoggedIn, queriedAddress, user]);

  const handleSaveAddressClick = () => {
    setUserAddress(queriedAddress);
    setModalVisible(false);
  };

  return (
    <div id="elections-content">
      <div id="intro-container">
        <h1>Upcoming Elections</h1>
        {foundElections === 'none' && (
          <p className="nav-message" id="none-found">Sorry, we didn&apos;t find any elections for the address you provided. Check out all upcoming elections in the U.S. below.</p>
        )}
        {foundElections === 'multiple' && queriedAddress && (
          <p className="nav-message" id="multiple-elections">Upcoming elections for {queriedAddress}</p>
        )}
      </div>
      <div id="content-container">
        {isLoading ? (
          <div id="loading-container">
            <p>Loading...</p>
          </div>
        ) : (
          <>
            <div id="info-container-parent">
              {Object.entries(electionsByMonth).map(([month, electionsInMonth]) => {
                return (
                  <div className="month-container">
                    <h2>{month}</h2>
                    <div className="info-container">
                      {electionsInMonth.map((election) => {
                        const {
                          title,
                          date,
                          _id,
                        } = election;

                        const saved = userSavedElections.includes(_id);
                        const address = userElectionsByAddress.includes(_id);

                        return (
                          <>
                            <div className="election-preview"
                              key={election._id}
                              onClick={() => {
                                sendEvent(ANALYTICS_CATEGORIES.ELECTIONS, ANALYTICS_ACTIONS.SET);
                                setSelectedElection(election._id);
                                history.push(`/elections/${election._id}`);
                              }}
                            >
                              <h4>{title}</h4>
                              <p>{moment(date).utc().format('MMMM Do, YYYY')}</p>
                            </div>
                            {(saved || address) && (
                            <div>
                              {saved && <img id="saved-icon" src={heartFilled} alt="filled heart" />}
                              {address && <img id="address-icon" src={locationPin} alt="address pin" />}
                            </div>
                            )}
                          </>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
            <div id="add-container">
              <h3>Know of an election not reported here?</h3>
              <p>Help us improve our application by providing information on it.</p>
              <button id="add-election-button" type="button" onClick={() => history.push('/elections/new')}>Add Election</button>
            </div>
          </>
        )}
      </div>
      <Rodal visible={modalVisible} onClose={() => setModalVisible(false) || setUserSeenAddressPrompt(true)}>
        <div id="modal-save-address-content">
          <h2>Save this address to your account?</h2>
          <p>We&apos;ll use it to auto-find future elections for you.</p>
          <p>This will override any previously stored address.</p>
          <p id="address">{queriedAddress}</p>
          <div id="button-container">
            <button type="button" onClick={handleSaveAddressClick}>
              Save Address
            </button>
            <button type="button" onClick={() => setModalVisible(false) || setUserSeenAddressPrompt(true)}>
              No Thanks
            </button>
          </div>
        </div>
      </Rodal>
    </div>
  );
};

export default Elections;
